import React, { useState } from 'react';
import { InstagramIcon, FacebookIcon, YoutubeIcon, MailIcon, HeartIcon, SparklesIcon } from 'lucide-react';
import { Modal } from './Modal';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsAndConditions } from './TermsAndConditions';
import { ContactForm } from './ContactForm';
import { SupportContent } from './SupportContent';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | 'contact' | 'support' | null>(null);
  return <>
      <footer className="bg-gradient-to-br from-baby-pink-light via-baby-cream to-baby-blue-light relative overflow-hidden" data-id="element-482">
        {/* Decorative Elements */}
        <div className="absolute top-0 left-0 w-40 h-40 bg-baby-pink/20 rounded-full blur-3xl animate-float-slow" data-id="element-483"></div>
        <div className="absolute bottom-0 right-0 w-48 h-48 bg-baby-blue/20 rounded-full blur-3xl animate-float" data-id="element-484"></div>
        <div className="absolute top-1/2 left-1/2 w-32 h-32 bg-baby-lavender/20 rounded-full blur-3xl" data-id="element-485"></div>

        <div className="max-w-6xl mx-auto px-4 py-12 sm:py-16 relative" data-id="element-486">
          {/* Newsletter Section - Featured */}
          <div className="mb-12 sm:mb-16" data-id="element-487"></div>

          {/* Simplified Footer Links - 2 Columns Only */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 mb-12 max-w-2xl mx-auto" data-id="element-488">
            {/* Ayuda */}
            <div className="bg-white/80 backdrop-blur-baby rounded-baby-lg p-6 sm:p-8 border-2 border-baby-pink-light shadow-baby-soft" data-id="element-489">
              <h4 className="font-extrabold mb-5 text-lg sm:text-xl text-gray-900 flex items-center gap-2" data-id="element-490">
                <span className="text-2xl" data-id="element-491">💬</span> Ayuda & Soporte
              </h4>
              <ul className="space-y-3.5 text-sm sm:text-base" data-id="element-492">
                <li data-id="element-493">
                  <a href="#" className="text-gray-800 hover:text-baby-pink transition font-semibold flex items-center gap-2 group" data-id="element-494">
                    <span className="group-hover:translate-x-1 transition-transform" data-id="element-495">
                      →
                    </span>{' '}
                    Preguntas Frecuentes
                  </a>
                </li>
                <li data-id="element-496">
                  <button onClick={() => setActiveModal('support')} className="text-gray-800 hover:text-baby-pink transition font-semibold flex items-center gap-2 text-left group" data-id="element-497">
                    <span className="group-hover:translate-x-1 transition-transform" data-id="element-498">
                      →
                    </span>{' '}
                    Centro de Soporte
                  </button>
                </li>
                <li data-id="element-499">
                  <button onClick={() => setActiveModal('contact')} className="text-gray-800 hover:text-baby-pink transition font-semibold flex items-center gap-2 text-left group" data-id="element-500">
                    <span className="group-hover:translate-x-1 transition-transform" data-id="element-501">
                      →
                    </span>{' '}
                    Contacto
                  </button>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div className="bg-white/80 backdrop-blur-baby rounded-baby-lg p-6 sm:p-8 border-2 border-baby-blue-light shadow-baby-soft" data-id="element-502">
              <h4 className="font-extrabold mb-5 text-lg sm:text-xl text-gray-900 flex items-center gap-2" data-id="element-503">
                <span className="text-2xl" data-id="element-504">⚖️</span> Legal
              </h4>
              <ul className="space-y-3.5 text-sm sm:text-base" data-id="element-505">
                <li data-id="element-506">
                  <button onClick={() => setActiveModal('terms')} className="text-gray-800 hover:text-baby-blue transition font-semibold flex items-center gap-2 text-left group" data-id="element-507">
                    <span className="group-hover:translate-x-1 transition-transform" data-id="element-508">
                      →
                    </span>{' '}
                    Términos y Condiciones
                  </button>
                </li>
                <li data-id="element-509">
                  <button onClick={() => setActiveModal('privacy')} className="text-gray-800 hover:text-baby-blue transition font-semibold flex items-center gap-2 text-left group" data-id="element-510">
                    <span className="group-hover:translate-x-1 transition-transform" data-id="element-511">
                      →
                    </span>{' '}
                    Política de Privacidad
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Social Links - 3D Enhanced */}
          <div className="mb-10" data-id="element-512">
            <p className="text-center text-gray-700 font-bold mb-5 text-sm sm:text-base" data-id="element-513">
              Síguenos en Redes Sociales 💕
            </p>
            <div className="flex justify-center gap-6 sm:gap-8" style={{
            perspective: '1000px'
          }} data-id="element-514">
              {/* Instagram - 3D Icon */}
              <a href="https://www.instagram.com/kiosscodigital/" target="_blank" rel="noopener noreferrer" className="group relative" style={{
              transformStyle: 'preserve-3d'
            }} data-id="element-515">
                <div className="w-16 h-16 sm:w-20 sm:h-20 relative transition-all duration-500 ease-out group-hover:scale-110 group-hover:-translate-y-2" style={{
                transformStyle: 'preserve-3d',
                transform: 'rotateX(10deg) rotateY(-10deg)'
              }} data-id="element-516">
                  {/* 3D Layers */}
                  <div className="absolute inset-0 bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 rounded-2xl shadow-2xl" style={{
                  transform: 'translateZ(8px)'
                }} data-id="element-517"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-purple-700 via-pink-600 to-orange-500 rounded-2xl" style={{
                  transform: 'translateZ(6px)'
                }} data-id="element-518"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-purple-800 via-pink-700 to-orange-600 rounded-2xl" style={{
                  transform: 'translateZ(4px)'
                }} data-id="element-519"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-pink-800 to-orange-700 rounded-2xl" style={{
                  transform: 'translateZ(2px)'
                }} data-id="element-520"></div>

                  {/* Icon */}
                  <div className="absolute inset-0 flex items-center justify-center" style={{
                  transform: 'translateZ(10px)'
                }} data-id="element-521">
                    <InstagramIcon className="w-8 h-8 sm:w-10 sm:h-10 text-white drop-shadow-lg" data-id="element-522" />
                  </div>

                  {/* Glow Effect */}
                  <div className="absolute inset-0 bg-gradient-to-br from-purple-400 via-pink-400 to-orange-300 rounded-2xl blur-xl opacity-0 group-hover:opacity-70 transition-opacity duration-500" style={{
                  transform: 'translateZ(-5px)'
                }} data-id="element-523"></div>
                </div>
              </a>

              {/* Facebook - 3D Icon */}
              <a href="https://www.facebook.com/contactokd/" target="_blank" rel="noopener noreferrer" className="group relative" style={{
              transformStyle: 'preserve-3d'
            }} data-id="element-524">
                <div className="w-16 h-16 sm:w-20 sm:h-20 relative transition-all duration-500 ease-out group-hover:scale-110 group-hover:-translate-y-2" style={{
                transformStyle: 'preserve-3d',
                transform: 'rotateX(10deg) rotateY(-10deg)'
              }} data-id="element-525">
                  {/* 3D Layers */}
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl shadow-2xl" style={{
                  transform: 'translateZ(8px)'
                }} data-id="element-526"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl" style={{
                  transform: 'translateZ(6px)'
                }} data-id="element-527"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-700 to-blue-900 rounded-2xl" style={{
                  transform: 'translateZ(4px)'
                }} data-id="element-528"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-800 to-blue-950 rounded-2xl" style={{
                  transform: 'translateZ(2px)'
                }} data-id="element-529"></div>

                  {/* Icon */}
                  <div className="absolute inset-0 flex items-center justify-center" style={{
                  transform: 'translateZ(10px)'
                }} data-id="element-530">
                    <FacebookIcon className="w-8 h-8 sm:w-10 sm:h-10 text-white drop-shadow-lg" data-id="element-531" />
                  </div>

                  {/* Glow Effect */}
                  <div className="absolute inset-0 bg-blue-400 rounded-2xl blur-xl opacity-0 group-hover:opacity-70 transition-opacity duration-500" style={{
                  transform: 'translateZ(-5px)'
                }} data-id="element-532"></div>
                </div>
              </a>

              {/* YouTube - 3D Icon */}
              <a href="https://www.youtube.com/@mikioscodigital" target="_blank" rel="noopener noreferrer" className="group relative" style={{
              transformStyle: 'preserve-3d'
            }} data-id="element-533">
                <div className="w-16 h-16 sm:w-20 sm:h-20 relative transition-all duration-500 ease-out group-hover:scale-110 group-hover:-translate-y-2" style={{
                transformStyle: 'preserve-3d',
                transform: 'rotateX(10deg) rotateY(-10deg)'
              }} data-id="element-534">
                  {/* 3D Layers */}
                  <div className="absolute inset-0 bg-gradient-to-br from-red-500 to-red-700 rounded-2xl shadow-2xl" style={{
                  transform: 'translateZ(8px)'
                }} data-id="element-535"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-red-600 to-red-800 rounded-2xl" style={{
                  transform: 'translateZ(6px)'
                }} data-id="element-536"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-red-700 to-red-900 rounded-2xl" style={{
                  transform: 'translateZ(4px)'
                }} data-id="element-537"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-red-800 to-red-950 rounded-2xl" style={{
                  transform: 'translateZ(2px)'
                }} data-id="element-538"></div>

                  {/* Icon */}
                  <div className="absolute inset-0 flex items-center justify-center" style={{
                  transform: 'translateZ(10px)'
                }} data-id="element-539">
                    <YoutubeIcon className="w-8 h-8 sm:w-10 sm:h-10 text-white drop-shadow-lg" data-id="element-540" />
                  </div>

                  {/* Glow Effect */}
                  <div className="absolute inset-0 bg-red-400 rounded-2xl blur-xl opacity-0 group-hover:opacity-70 transition-opacity duration-500" style={{
                  transform: 'translateZ(-5px)'
                }} data-id="element-541"></div>
                </div>
              </a>
            </div>
          </div>

          {/* Copyright - Enhanced */}
          <div className="text-center border-t-2 border-baby-lavender pt-8" data-id="element-542">
            <p className="text-gray-700 text-xs sm:text-sm mb-4 px-4 font-medium max-w-2xl mx-auto" data-id="element-543">
              Los resultados pueden variar según la consistencia de
              implementación del sistema. Consulta con un pediatra antes de
              introducir nuevos alimentos.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-gray-900 font-bold text-sm sm:text-base" data-id="element-544">
              <span data-id="element-545">© 30 Recetas para Bebés</span>
              <span className="hidden sm:inline" data-id="element-546">•</span>
              <span className="flex items-center gap-2" data-id="element-547">
                Hecho con{' '}
                <HeartIcon className="w-4 h-4 text-baby-pink fill-baby-pink animate-soft-pulse" data-id="element-548" />{' '}
                para tu bebé
              </span>
            </div>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-549">
        <PrivacyPolicy data-id="element-550" />
      </Modal>
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-551">
        <TermsAndConditions data-id="element-552" />
      </Modal>
      <Modal isOpen={activeModal === 'contact'} onClose={() => setActiveModal(null)} title="Contacto" data-id="element-553">
        <ContactForm data-id="element-554" />
      </Modal>
      <Modal isOpen={activeModal === 'support'} onClose={() => setActiveModal(null)} title="Centro de Soporte" data-id="element-555">
        <SupportContent data-id="element-556" />
      </Modal>
    </>;
}